import api from '../../api/_sortie'

const state = () => ({
    sorties: [],
    destokages: [],
    sortie: [],
})

// getters
const getters = {
    sorties: (state) => {
        return state.sorties;
    },
    destokages: (state) => {
        return state.destokages;
    },

    destockageListe: (state) => {
        return state.sorties;
    },

    sortie: (state) => {
        return state.sortie;
    },
};

// mutations
const mutations = {
    SET_SORTIES(state, sorties) {
        state.sorties = sorties;
    },
    SET_DESTOCKAGES(state, sorties) {
        state.destokages = sorties;
    },

    SET_FILTRAGEDESTOCKAGE(state, sorties) {
        state.sorties = sorties;
    },
    SET_DESTOCKAGELISTE(state, sorties) {
        state.sorties = sorties;
    },

    SET_SORTIE(state, sortie) {
        state.sortie = sortie;
    },
};

// actions
const actions = {
    /**
     * Liste des  sortieS
     */
    getSorties({ commit }) {
        api.sorties().then((response) => {
            commit("SET_SORTIES", response);
        });
    },
    
    /**
     * Liste des  destokages
     */
    getDestockageListes({ commit }) {
        return new Promise((resolve, reject) => {
            api.getDestockageListes().then(
                (response) => {
                    commit("SET_DESTOCKAGES", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    saveSortie({ dispatch }, data) {
        return api.saveSortie(data).then((response) => {
            dispatch("getSorties");
            return response.sortie;
        });
    },

    getsortie({ commit }, id) {
        api.getSortie(id).then((response) => {
            commit("SET_SORTIE", response);
        });
    },
};



export default {
    state,
    getters,
    actions,
    mutations
}
